/** @format */

import template from './gb-add-image-widget.html';

export const GbAddImageWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddImageWidgetComponent {
        constructor(
            $gbImageProjectorWidget,
            $translate,
            $gbAuctionImage,
            $gbTask,
            $log,
            $ccToast,
            LoadingHelper,
            $ccLoading
        ) {
            'ngInject';

            this.$gbImageProjectorWidget = $gbImageProjectorWidget;
            this.$translate = $translate;
            this.$gbAuctionImage = $gbAuctionImage;
            this.$gbTask = $gbTask;
            this.$log = $log;
            this.$ccToast = $ccToast;

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);

            this.image = null;
        }

        addWidget() {
            this.widget = new this.$gbImageProjectorWidget({
                image: this.image,
                x: 50,
                y: 50,
                x_unit: '%',
                y_unit: '%',
                width: 20,
                width_unit: '%',
                height: null,
                height_unit: '%',
                opacity: 1,
            });

            this.gbPresenter.tempWidgets.push(this.widget);
        }

        handleFileUpload() {
            if (!!this.imageToUpload) {
                let loader = this.loadingHelper.push('UPLOADING_IMAGE');

                return this.$gbAuctionImage
                    .uploadImage(this.imageToUpload, {
                        url_name: this.gbApp.getAuctionUrl(),
                    })
                    .then((response) => {
                        this.$log.info('Started Upload Task...', response);

                        return this.$gbTask
                            .get({
                                uuid: response.blackboard_uuid,
                            })
                            .$promise.then((data) => {
                                let auctionImage = data.results;
                                this.$log.info('Image Upload Complete!', data);

                                this.$gbAuctionImage.cache.push(auctionImage);
                                this.image = auctionImage;

                                this.addWidget();
                            });
                    })
                    .catch((err) => {
                        this.$ccToast.error(err);
                        throw err;
                    })
                    .finally(() => {
                        loader();
                    });
            }
        }

        $onDestroy() {
            this.loadingWatcher();
        }
    },
};
